<template>
  <div class="d-flex " :style="{ width }">
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
      :name="label"
      :vid="name"
      :style="{ display: 'inline-block',  width: '100%' }"
    >
    <template v-if="!timePicker">
      <el-date-picker
        v-model="localValue"
        :class="$style['date-picker']"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        :data-vv-as="label"
        :name="name"
        data-vv-validate-on="input|change"
      />
    </template>
    <template v-else>
      <VueCtkDateTimePicker
        v-model="localValue"
        :class="$style['date-picker']"
        :minute-interval="60"
        :format="'YYYY-MM-DD HH'"
        label=""
        no-label
        :min-date="disableDates"
      />
    </template>
      <div
        v-if="!hideDetails"
        :class="$style['error-message']"
        v-html="errors[0]"
      />
    </ValidationProvider>
    <div v-if="remarks" :class="$style['remarks']">{{ remarks }}</div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: {},
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    width: {
      type: String,
      default: "200px"
    },
    remarks: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    timePicker: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      icon: "event"
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    disableDates() {
      return moment().add(1,'hours').format("YYYY-MM-DD HH");
    }
  }
};
</script>

<style module lang="scss">
.date-picker {
  margin-bottom: 8px;
  width: 100% !important;
}
.error-message {
  min-height: 23px;
  line-height: 1;
  padding: 0 12px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}
.remarks {
  &:before {
    content: "※";
    font-size: 18px;
    margin-right: 2px;
  }
  margin: 4px 0 0 4px;
  font-size: 12px;
  color: #666;
}
</style>
